








































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { Token } from "../utils/Token";
import { EventBus } from "../event-bus";

@Component({
  components: {},
})
export default class Keys extends Vue {
  @Prop() user!: any;

  private keys: any[] = [];
  private leftKeys = 0;

  created() {
    const id = this.user.accountId;
    this.fetchKeys(this.user.accountId);
  }

  private async fetchKeys(id: number) {
    this.keys = []; // clear prior log table
    const token = await Token.getTokenWithExpiry("token");

    ////EventBus.$emit("BeginLoader",null );   
    axios({
      method: "get",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/device/aeskeys/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        ////EventBus.$emit("FinishLoader",null );   

        console.log("response of get account:", response);
        this.leftKeys = response.data.leftKeys;
        response.data.keys.forEach((result: any) => {
          this.keys.push(result);
        });
        console.log(this.keys);
      })
      .catch((err) => {
        ////EventBus.$emit("FinishLoader",null );   

        console.log("error:", err);
      });
  }

  private headers = [
    {
      text: "ID",
      align: "start",
      value: "id",
      sortable: true,
    },
    {
      text: "Key",
      value: "key",
      sortable: false,
      align: "start",
    },
    {
      text: "Length",
      value: "length",
      sortable: true,
      align: "start",
    },
    {
      text: "Type",
      value: "type",
      sortable: false,
      align: "start",
    },
    /* @MOFA: Uncomment this if we want to keep it.
    {
      text: "Used",
      value: "used",
      sortable: true,
    },
    */
  ];
}
